export const VOTE_LOAD = '@vote/load';
